import { openLocalFileWithNewWindow } from '@jove-frontend/utils';
import { Article, DeleteOutline, OpenInNewOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JoveLocalFileListItemView = function JoveLocalFileListItemView(props) {
  var _info$file;

  var className = props.className,
      info = props.info,
      deleteItem = props.deleteItem,
      _props$size = props.size,
      size = _props$size === void 0 ? 'normal' : _props$size,
      hideOpenFile = props.hideOpenFile;
  /**
   * methods
   */

  var deleteAction = function deleteAction() {
    deleteItem === null || deleteItem === void 0 ? void 0 : deleteItem(info);
  };

  var openFileAction = function openFileAction() {
    if (info.file instanceof File) {
      // const url = URL.createObjectURL(info.file);
      // window.open(url, '_blank');
      openLocalFileWithNewWindow(info.file);
    }
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('border-grey-10 flex flex-row items-center rounded-xl border', className),
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex w-0 flex-1 flex-row items-center",
      children: [/*#__PURE__*/_jsx(Box, {
        className: clsx('bg-light-blue flex items-center justify-center rounded-lg', size === 'small' ? 'h-8 w-8' : 'h-12 w-12'),
        children: /*#__PURE__*/_jsx(Article, {
          className: clsx('text-brand-secondary', size === 'small' ? 'h-5 w-5' : 'h-6 w-6')
        })
      }), /*#__PURE__*/_jsxs(Box, {
        className: "ml-4 flex flex-col space-y-1",
        children: [/*#__PURE__*/_jsx(Typography, {
          className: clsx('font-bold', size === 'small' ? 'text-sm' : 'text-lg'),
          children: info === null || info === void 0 ? void 0 : (_info$file = info.file) === null || _info$file === void 0 ? void 0 : _info$file.name
        }), /*#__PURE__*/_jsx(Typography, {
          className: clsx('text-xs font-medium'),
          children: info === null || info === void 0 ? void 0 : info.sizeText
        })]
      })]
    }), !hideOpenFile && /*#__PURE__*/_jsx(IconButton, {
      onClick: openFileAction,
      children: /*#__PURE__*/_jsx(OpenInNewOutlined, {
        className: "h-6 w-6"
      })
    }), !(info !== null && info !== void 0 && info.hideDeleteButton) && /*#__PURE__*/_jsx(IconButton, {
      onClick: deleteAction,
      children: /*#__PURE__*/_jsx(DeleteOutline, {
        className: "h-6 w-6"
      })
    })]
  });
};

export default JoveLocalFileListItemView;